import defaultLayout from "@/layouts/side-nav-outer-toolbar";
import loadView from "../../common/loadView";

export default [
	{
		path: "/car-color/:mode/:oid?",
		name: "car-color",
		meta: {
			requiresAuth: true,
			requiresPermission: true,
			layout: defaultLayout,
			permission: "Цвет авто",
		},
		component: loadView("car-colores/car-colores-detail-view"),
	},
	{
		path: "/car-colores",
		name: "car-colores",
		meta: {
			requiresAuth: true,
			requiresPermission: true,
			layout: defaultLayout,
			permission: "Цвет авто",
		},
		component: loadView("car-colores/car-colores-list-view"),
	},
];
